import { getApplicant } from './getApplicant';

export const applicant = {
  applicant: getApplicant,
};
